var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-link',_vm._b({attrs:{"to":_vm.$pagePath('index')}},'vs-link',_vm.$attrs,false),[_c('vs-image',{attrs:{"src":"/logo.svg","fit":"contain","position":"left","negative-margin-top":"xs","alt":"Statica"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }